'use client';

import { useEffect } from 'react';
import {
  createPerformanceObserver,
  monitorInteractions,
} from '@/utils/performanceMonitor';

export default function PerformanceProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const perfObserver = createPerformanceObserver();
    const interactionObserver = monitorInteractions();

    return () => {
      perfObserver?.disconnect();
      interactionObserver?.disconnect();
    };
  }, []);

  return <>{children}</>;
}
